var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard__card-loading" }, [
    _c(
      "div",
      [_c("MoonLoader", { attrs: { size: "75px", color: "#ffffff" } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "loadingText" }, [_vm._v("Loading...")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }